var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Accordion, Button, Row, Col } from "@folio/stripes/components";
import { FormattedMessage, useIntl } from "react-intl";
import { Controller, useFormContext, useFieldArray } from "react-hook-form";
import { RecekTextField, RecekOnixItemPicker } from "../inputs";
import { useOnixOptions } from "../../hooks/title/useOnixOptions";
import { preferredOnix } from "../../utils/selectMappers";
/** ONIX Extent unit (codetable 24) code for "Strany" (pages). */
var EXTENT_UNIT_PAGES = "03";
export var ProductExtentsSection = function (_a) {
    var open = _a.open, onToggle = _a.onToggle;
    var formatMessage = useIntl().formatMessage;
    var control = useFormContext().control;
    var _b = useOnixOptions(), extentTypeTable = _b.extentTypeTable, extentUnitTable = _b.extentUnitTable, extentTypeStatus = _b.extentTypeStatus, extentUnitStatus = _b.extentUnitStatus;
    var _c = useFieldArray({
        control: control,
        name: "extents",
    }), extentFields = _c.fields, appendExtent = _c.append, removeExtent = _c.remove;
    var handleAddExtent = function () {
        appendExtent({
            type: extentTypeTable === null || extentTypeTable === void 0 ? void 0 : extentTypeTable.onixCodetableItems[0],
            value: undefined,
            // Default the unit to "Strany" (pages) by its ONIX code (24/03) rather
            // than by array index, which depends on the codetable's sort_order.
            unit: preferredOnix(extentUnitTable, EXTENT_UNIT_PAGES),
        });
    };
    return (React.createElement(Accordion, { label: formatMessage({
            id: "ui-br-agency.product.accordion.extents",
        }), open: open, onToggle: onToggle },
        extentFields.map(function (field, index) { return (React.createElement(Row, { key: field.id, style: { marginBottom: "10px" } },
            React.createElement(Col, { xs: 4 },
                React.createElement(Controller, { control: control, name: "extents.".concat(index, ".type"), render: function (_a) {
                        var _b, _c;
                        var controllerField = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.product.extent.type.label", dataOptions: (_b = extentTypeTable === null || extentTypeTable === void 0 ? void 0 : extentTypeTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [], codetableStatus: extentTypeStatus, value: controllerField.value, onChange: controllerField.onChange, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true }));
                    } })),
            React.createElement(Col, { xs: 3 },
                React.createElement(Controller, { control: control, name: "extents.".concat(index, ".value"), render: function (_a) {
                        var _b;
                        var field = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.product.extent.value.label", type: "number", error: (_b = fieldState.error) === null || _b === void 0 ? void 0 : _b.message, required: true })));
                    } })),
            React.createElement(Col, { xs: 3 },
                React.createElement(Controller, { control: control, name: "extents.".concat(index, ".unit"), render: function (_a) {
                        var _b, _c;
                        var controllerField = _a.field, fieldState = _a.fieldState;
                        return (React.createElement(RecekOnixItemPicker, { labelId: "ui-br-agency.product.extent.unit.label", dataOptions: (_b = extentUnitTable === null || extentUnitTable === void 0 ? void 0 : extentUnitTable.onixCodetableItems) !== null && _b !== void 0 ? _b : [], codetableStatus: extentUnitStatus, value: controllerField.value, onChange: controllerField.onChange, error: (_c = fieldState.error) === null || _c === void 0 ? void 0 : _c.message, required: true }));
                    } })),
            React.createElement(Col, { xs: 2 },
                React.createElement(Button, { buttonStyle: "danger", marginBottom0: true, onClick: function () { return removeExtent(index); } },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.remove" }))))); }),
        React.createElement(Button, { buttonStyle: "default", onClick: handleAddExtent },
            React.createElement(FormattedMessage, { id: "ui-br-agency.product.extent.add" }))));
};
